import React from 'react';
import { AlertTriangle } from 'lucide-react';

export function taskPlanIsActive(item) {
  return !['complete', 'completed', 'closed', 'cancelled', 'canceled', 'removed', 'removed_bad_import', 'complied'].includes(String(item.disposition || item.status || '').trim().toLowerCase());
}

const number = value => Number(value.toFixed(1)).toLocaleString();
const calendarDays = date => Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86400000;

function timingStatus(item, deadline, proximity) {
  const meterBased = proximity && Number.isFinite(proximity.remaining) && !['days', 'DY', 'DD', 'DAY', 'DAYS'].includes(proximity.basis);
  if (meterBased) {
    const remaining = proximity.remaining;
    const units = proximity.basis || 'units';
    if (remaining < 0) return { level: 'overdue', text: `OVERDUE · ${number(-remaining)} ${units} overdue` };
    if (proximity.level === 'overdue') return { level: 'overdue', text: 'OVERDUE · review due/current readings' };
    if (remaining === 0) return { level: 'critical', text: `DUE NOW · 0 ${units} remaining` };
    return { level: proximity.level, text: `${['critical', 'warning'].includes(proximity.level) ? 'DUE SOON' : 'DUE'} · ${number(remaining)} ${units} remaining` };
  }
  const due = deadline ? new Date(deadline) : null;
  const days = due && Number.isFinite(due.getTime()) ? calendarDays(due) - calendarDays(new Date()) : Number.isFinite(proximity?.remaining) ? proximity.remaining : null;
  const overdueDays = Number(item.overdueDays) > 0 ? Number(item.overdueDays) : days < 0 ? -days : null;
  if (overdueDays) return { level: 'overdue', text: `OVERDUE · ${number(overdueDays)} ${overdueDays === 1 ? 'day' : 'days'} overdue` };
  if (days === 0) return { level: 'critical', text: 'DUE TODAY' };
  if (item.overdueSince || proximity?.level === 'overdue') return { level: 'overdue', text: 'OVERDUE · due date needs review' };
  if (days !== null) return { level: proximity?.level || 'normal', text: `${['critical', 'warning'].includes(proximity?.level) ? 'DUE SOON' : 'DUE'} · ${days} ${days === 1 ? 'day' : 'days'} remaining` };
  return null;
}

// Shared presentation; each task type supplies its own due basis and planning rules.
export default function TaskPlanReview({ item, deadline, proximity, thresholdDetails, warnings = [] }) {
  if (!taskPlanIsActive(item)) return null;
  const timing = timingStatus(item, deadline, proximity);
  const concerns = [...new Set([...warnings, item.scheduleWarning?.message].filter(Boolean))];
  if (!timing && !thresholdDetails && !concerns.length) return null;
  return <div className="task-plan-review">
    {timing ? <span className={`task-plan-review__timing is-${timing.level}`}>{timing.text}</span> : null}
    {thresholdDetails ? <details className="task-plan-review__threshold"><summary>Threshold details</summary><span>{thresholdDetails}</span></details> : null}
    {concerns.map(message => <span className="task-plan-review__warning" key={message}><AlertTriangle size={14} aria-hidden="true" />{message}</span>)}
  </div>;
}
